__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "CSP";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@fluentui/react", "8.115.6", () => (Promise.all([__webpack_require__.e("vendors-node_modules_fluentui_react-hooks_lib_useId_js"), __webpack_require__.e("vendors-node_modules_fluentui_date-time-utilities_lib_dateFormatting_dateFormatting_defaults_-8e9161"), __webpack_require__.e("vendors-node_modules_fluentui_react_lib_index_js")]).then(() => (() => (__webpack_require__("./node_modules/@fluentui/react/lib/index.js"))))));
			register("@fluentui/react", "8.123.0", () => (Promise.all([__webpack_require__.e("vendors-node_modules_fluentui_react-hooks_lib_useId_js"), __webpack_require__.e("vendors-node_modules_fluentui_date-time-utilities_lib_dateFormatting_dateFormatting_defaults_-8e9161"), __webpack_require__.e("vendors-node_modules_coherence-design-system_tag_node_modules_fluentui_react_lib_index_js"), __webpack_require__.e("node_modules_fluentui_react-hooks_lib_useBoolean_js-node_modules_coherence-design-system_tag_-487d9e")]).then(() => (() => (__webpack_require__("./node_modules/@coherence-design-system/tag/node_modules/@fluentui/react/lib/index.js"))))));
			register("@fxp/fxpservices-di", "9.0.1", () => (__webpack_require__.e("vendors-node_modules_fxp_fxpservices-di_index_js").then(() => (() => (__webpack_require__("./node_modules/@fxp/fxpservices-di/index.js"))))));
			register("@fxp/staterouter", "10.0.1", () => (Promise.all([__webpack_require__.e("vendors-node_modules_redux-micro-frontend_index_js"), __webpack_require__.e("webpack_sharing_consume_default_fxp_fxpservices-di_fxp_fxpservices-di"), __webpack_require__.e("node_modules_fxp_staterouter_index_js-_3fa31")]).then(() => (() => (__webpack_require__("./node_modules/@fxp/staterouter/index.js"))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};